export const msalConfigPRD = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_PRD,
    authority:
      'https://login.microsoftonline.com/' + process.env.REACT_APP_TENANT_ID,
    redirectUri: `${process.env.REACT_APP_FQDN_PRD}`,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
  },
}

export const msalConfigSTG = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_STG,
    authority: 'https://login.microsoftonline.com/organizations',
    // 'https://login.microsoftonline.com/' + process.env.REACT_APP_TENANT_ID,
    redirectUri: `${process.env.REACT_APP_FQDN_STG}`,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
  },
}

export const msalConfigLocal = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_STG,
    authority: 'https://login.microsoftonline.com/organizations',
    // 'https://login.microsoftonline.com/' + process.env.REACT_APP_TENANT_ID,
    redirectUri: 'http://localhost:3000/',
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
  },
}

export const msalVicOne = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_VICONE,
    authority:
      'https://login.microsoftonline.com/' +
      process.env.REACT_APP_TENANT_ID_VICONE,
    redirectUri:
      process.env.REACT_APP_ENV == 'production'
        ? process.env.REACT_APP_FQDN_PRD
        : process.env.REACT_APP_FQDN_STG,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
  },
}

export const msalVicOneLocal = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_VICONE,
    authority:
      'https://login.microsoftonline.com/' +
      process.env.REACT_APP_TENANT_ID_VICONE,
    redirectUri: 'http://localhost:3000/',
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
  authority: 'https://login.microsoftonline.com/organizations',
}

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
